module.exports = __webpack_public_path__ + "img/18-800x800.ef7b001a.jpg";